import React, { useEffect } from "react";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/federo/400.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import { Box } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { loadReCaptcha } from "react-recaptcha-v3";
import { AuthProvider } from "context/Auth";
import { HelpWorkflowProvider } from "context/HelpWorkflowContext";
import { MapboxCacheProvider } from "hooks/useMapboxCache";
import { AppRoutes } from "routes/AppRoutes";
import AppThemeShell from "components/layout/AppThemeShell";
import AppPageShell from "components/layout/AppPageShell";
import VoxPontFaviconManager from "pages/voxpontmarketing/VoxPontFaviconManager";
import VoxPontSaveAsAppManager from "features/voxpontShared/VoxPontSaveAsAppManager";
import FusionMsiFaviconManager from "features/decisionPoint/components/FusionMsiFaviconManager";
import AsiFaviconManager from "features/asi/components/AsiFaviconManager";
import { initSentry } from "config/sentry";
/** Styled-components theme — aligned to MUI brand colors; removal candidate (see UI Fix Batch 1). */
import theme from "utils/helpers/theme";

const routerFuture = { v7_startTransition: true, v7_relativeSplatPath: true };

// Initialize Sentry
initSentry();

function App() {
  useEffect(() => {
    // Skip reCAPTCHA for Kijabe pages - check BOTH path and iframe
    const isKijabeDashboard =
      window.location.pathname.includes("kijabe-dashboard");
    const isIframe = window !== window.parent;
    const isProduction = process.env.REACT_APP_ENVIRONMENT === "production";

    // Don't load reCAPTCHA if we're on kijabe-dashboard, in an iframe, or not in production
    if (!isKijabeDashboard && !isIframe && isProduction) {
      loadReCaptcha(process.env.REACT_APP_RECAPTCHA_SITE_KEY, () => {});
    }
  }, []);

  const api_regex = /^\/api\/.*/;
  if (api_regex.test(window.location.pathname)) {
    return <div />;
  }

  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <HelpWorkflowProvider>
        <MapboxCacheProvider>
          <BrowserRouter future={routerFuture}>
            <AppThemeShell>
              <AppPageShell>
                <VoxPontFaviconManager />
                <VoxPontSaveAsAppManager />
                <FusionMsiFaviconManager />
                <AsiFaviconManager />
                <Box
                  sx={{
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <AppRoutes />
                </Box>
              </AppPageShell>
            </AppThemeShell>
          </BrowserRouter>
        </MapboxCacheProvider>
        </HelpWorkflowProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
